import {
    Component,
    EventEmitter, Input,
    ElementRef,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { ModalDirective } from "ngx-bootstrap/modal";
import QRCodeStyling from 'qr-code-styling';

@Component({
    selector: "QrCodeModal",
    templateUrl: "./qrCodeModal.component.html",
})
export class QrCodeModalComponent implements OnInit {
    @ViewChild("qrCodeModal") public thisModal: ModalDirective;
    @ViewChild("canvas", { static: true }) canvas: ElementRef;
    @Output() btnSaveQrCodeClicked = new EventEmitter<string>();
    @Output() btnShareQRClicked = new EventEmitter<string>();
    @Output() btnCloseQRClicked = new EventEmitter<string>();

    urlShare: string;
    qrCode: QRCodeStyling;
    constructor() { }

    ngOnInit(): void {
        this.urlShare = ""
    }

    updateQRCode(): void {
        if (!this.urlShare) {
            this.urlShare = "https://uj.fm/"
        }
        this.qrCode = new QRCodeStyling({
            width: 300,
            height: 300,
            type: "svg",
            data: this.urlShare,
            margin: 0,
            image: "assets/favicon192.png",
            dotsOptions: {
                color: "#000000",
                type: "square"
            },
            backgroundOptions: {
                color: "#ffffff",
            },
            imageOptions: {
                imageSize: 0.65,
                crossOrigin: "anonymous",
            }
        });

        this.qrCode.append(this.canvas.nativeElement);
    }

    onSaveQrCodeClicked() {
        // this.btnSaveQrCodeClicked.emit("");
        this.qrCode.download({ extension: 'svg' });
    }

    onShareQRClicked() {
        this.btnShareQRClicked.emit("");
    }

    onCloseQRClicked() {
        this.btnCloseQRClicked.emit("");
    }
}
